"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable max-len */
var TooltipText = {
  num_page_views: {
    title: 'Page Views',
    text: 'The total number of unique browsers that loaded this Knotch card.'
  },
  num_visitors: {
    title: 'Visitors',
    text: 'Unique browsers (based on a Knotch cookie id) that have loaded the Knotch card. For example, one person loading the page five times would count for five views but only one visitor.'
  },
  avg_time_on_page: {
    title: 'Time On Page',
    text: 'The total number of seconds spent on the page per visitor. Wherever a Knotch card is embedded, a visitor’s browser will make a request to Knotch every few seconds while that page is the active browser tab. When that tab is switched or the window is minimized, the Knotch timer will pause. Time values are reported as an average, removing outlying time values.'
  },
  num_responses: {
    title: 'Responses',
    text: 'The total number of responses to this Knotch question.'
  },
  pct_positive_responses: {
    title: 'Positive Responses',
    text: 'The percentage of responses that were a positive sentiment.'
  },
  pct_neutral_responses: {
    title: 'Neutral Responses',
    text: 'The percentage of responses that were a neutral sentiment.'
  },
  pct_negative_responses: {
    title: 'Negative Responses',
    text: 'The percentage of responses that were a negative sentiment.'
  },
  pct_clickthrough: {
    title: 'Clickthrough Rate',
    text: 'The percentage of visitors who clicked the post-response link or answered the secondary question, out of the total number of responders.'
  },
  top_age_group: {
    title: 'Top Age Group',
    text: 'The most prevalent age group to visit a piece of content.'
  },
  top_gender: {
    title: 'Top Gender',
    text: 'The most prevalent gender to visit a piece of content.'
  },
  demographics: {
    title: 'Demographics',
    text: 'The most prevalent gender & age group to visit a piece of content.'
  },
  num_total_shares: {
    title: 'Social',
    text: 'The lifetime sum of the content URL\'s social engagements across Facebook, Twitter, and Pinterest'
  },
  num_shares: {
    title: 'Social',
    text: 'The lifetime sum of the content URL\'s social engagements across Facebook, Twitter, and Pinterest'
  },
  knotch_score: {
    title: 'Knotch Score',
    text: 'The Knotch Score indicates how well this content has performed compared to your other content. Its ranking from 0 to 10 (10 being the best) equally weights visitors, average time on page, responses, positive responses, and clickthroughs. Content embedded with invisible Knotch cards will not receive a Knotch Score because these cards do not collect responses, positive responses, or clickthroughs.'
  },
  clickthrough_by_sentiment: {
    title: 'Clickthrough By Sentiment',
    text: 'The percentage of each of the sentiment options chosen by responders calculated by the total number of clickthroughs.'
  },
  average_sentiment: {
    title: 'Average Sentiment',
    text: 'The average way people felt about this content'
  },
  sentiment_breakdown: {
    title: 'Sentiment Breakdown',
    text: 'The distribution of how people felt about this content'
  },
  sentiment_over_time: {
    title: 'Sentiment Over Time',
    text: 'A chart tracking the respective card’s changes in lifetime sentiment by day.'
  },
  response_breakdown: {
    title: 'Response Breakdown',
    text: 'The distribution of how people responded to this content'
  },
  total_responses: {
    title: 'Total Responses',
    text: 'The number of visitors that submitted a response to the Knotch card question.'
  },
  total_clickthroughs: {
    title: 'Total Clickthroughs',
    text: 'The number of visitors who, after responding to the Knotch card, followed the redirect link offered to them after responding to the Knotch card question.'
  },
  city_by_sentiment: {
    title: 'City By Sentiment',
    text: 'The breakdown of sentiment by city'
  },
  country_by_sentiment: {
    title: 'Country By Sentiment',
    text: 'The breakdown of sentiment by country'
  },
  total_views: {
    title: 'Total Views',
    text: 'The number of times a unique Knotch card is loaded.'
  },
  traffic_over_time: {
    title: 'Traffic Over Time',
    text: 'A chart tracking the respective card’s changes in lifetime traffic by day.'
  },
  average_time_on_content: {
    title: 'Average Time On Content',
    text: 'The average time a user spends on this content.'
  },
  total_time_on_content: {
    title: 'Total Time On Content',
    text: 'The cumulative time spent viewing this content.'
  },
  traffic_by_age: {
    title: 'Traffic By Age',
    text: 'The percentage breakdown of traffic by age group.'
  },
  gender_breakdown: {
    title: 'Traffic By Gender',
    text: 'The percentage breakdown of traffic by gender.'
  },
  traffic_by_gender: {
    title: 'Traffic By Gender',
    text: 'The percentage breakdown of traffic by gender.'
  },
  city_by_traffic: {
    title: 'City By Traffic',
    text: 'The breakdown of traffic by city'
  },
  country_by_traffic: {
    title: 'Country By Traffic',
    text: 'The percentage of views received by content broken down by countries'
  },
  traffic_by_referrer: {
    title: 'Traffic By Referrer',
    text: 'JavaScript-based integrations are able to report on page referrals. Referral reporting will give the % of visitors from a given domain. Some amount of traffic may appear as direct or unknown - this indicates visitors who visited a page directly, or came from a secure source that prevents its referrer information from being known (e.g., email clients, IM clients, and certain apps and websites).'
  },
  device_breakdown: {
    title: 'Device Breakdown',
    text: 'The breakdown of traffic by device type.'
  },
  os_breakdown: {
    title: 'OS Breakdown',
    text: 'The breakdown of traffic by operating system.'
  },
  browser_breakdown: {
    title: 'Browser Breakdown',
    text: 'The breakdown of traffic by internet browser.'
  },
  mobile_os_breakdown: {
    title: 'Mobile OS Breakdown',
    text: 'The breakdown of traffic by mobile operating system.'
  },
  mobile_browser_breakdown: {
    title: 'Mobile Browser Breakdown',
    text: 'The breakdown of traffic by mobile browser.'
  },
  top_response: {
    title: 'Top Response',
    text: 'The most frequently selected sentiment option on the 5-point scale.'
  },
  top_responses: {
    title: 'Top Responses',
    text: 'The top responses to this question'
  },
  interaction_rate: {
    title: 'Interaction Rate',
    text: 'The percentage of visitors who interacted with the card card (hovered over it for 1+ second or clicked it), out of the total number of visitors.'
  },
  response_rate: {
    title: 'Response Rate',
    text: 'The percentage of visitors who responded to the card card out of the total number of interactions.'
  },
  total_visitors: {
    title: 'Total Visitors',
    text: 'Unique browsers (based on a Knotch cookie id) that have loaded the Knotch card. For example, one person loading the page five times would count for five views but only one visitor.'
  },
  num_unique_page_views: {
    title: 'Total Visitors',
    text: 'Unique browsers (based on a Knotch cookie id) that have loaded the Knotch card. For example, one person loading the page five times would count for five views but only one visitor.'
  },
  visitors: {
    title: 'Visitor Breakdown',
    text: 'The breakdown of visitors to this content in comparison to the average visitors in both this folder and all folders'
  },
  average_time_on_content_benchmark: {
    title: 'Average Time On Content Benchmark',
    text: 'The time spent on this content against content in this folder and all of your content'
  },
  time_on_content_breakdown: {
    title: 'Time On Content Breakdown',
    text: 'The breakdown of how many seconds were spent on this content by views'
  },
  knotch_score_folder: {
    title: 'Knotch Score',
    text: 'The average of all card Knotch Scores within a folder. The Knotch Score indicates how well this content has performed compared to your other content. It’s ranking from 0 to 10 (10 being the best) equally weights visitors, average time on page, responses,  positive responses, and clickthroughs.'
  },
  knotch_score_card: {
    title: 'Knotch Score',
    text: 'The Knotch Score indicates how well this content has performed compared to your other content. It’s ranking from 0 to 10 (10 being the best) equally weights visitors, average time on page, responses,  positive responses, and clickthroughs.'
  },
  overall: {
    title: 'Overall Sentiment By Referrer',
    text: 'The most common response by referral source'
  },
  pct_traffic: {
    title: 'Percentage of Traffic',
    text: 'The percentage of total views recieved by this referral source'
  },
  scroll_depth: {
    title: 'Scroll Depth',
    text: 'The percentage of visitors that have reached the determined quartiles of a content page, as well as the average time spent to reach each of them.'
  },
  contribution_to_brand_score: {
    title: 'Contribution to Brand Score',
    text: 'Average positive response rate & attention rate negatively impacted by the flee rate normalized to a 0-10 score'
  },
  positive_sentiment: {
    title: 'Positive Sentiment',
    text: 'The rate of positive responses divided by total number of responses.'
  },
  stay_rate: {
    title: 'Attention Rate',
    text: 'The rate of views that stayed more than a minimum amount of time & scrolled more than the minimum scroll percentage for this page.'
  },
  flee_rate: {
    title: 'Flee Rate',
    text: 'The rate of views that stayed less than a minimum amount of time & scrolled more than the minimum scroll percentage for this page.'
  },
  recirculation_score: {
    title: 'Recirculation Score',
    text: 'The number of pages views generated by the current page divided by the number of page views of the current page, normalized to a 0 to 10 score.'
  },
  content_activity_score: {
    title: 'Content Activity Score',
    text: 'The amount of user activity generated on a piece of content, normalized to a 0-10 score.'
  },
  benchmarks: {
    title: 'Benchmarks',
    text: 'A proprietary Knotch value that allows you to measure your performance against the industry standard.'
  },
  baseline: {
    title: 'Baseline',
    text: 'A proprietary Knotch value that shows you your initial value for a specific metric or score that we measure over the first month of your partnership with Knotch'
  },
  metric_over_time_section: {
    title: 'Metric Over Time',
    text: 'A visualization of the score or metric change over the time period selected.'
  },
  changes_section: {
    title: 'Changes',
    text: 'The % change of your score or metric from the previous period.'
  },
  content_contributors: {
    title: 'Content Contributors',
    text: 'The content pieces which have had the highest positive impact on this score or metric.'
  },
  content_detractors: {
    title: 'Content Detractors',
    text: 'The content pieces which have had the highest negative impact on this score or metric.'
  },
  user_journey_pie_chart: {
    title: 'Single page session vs user journey',
    text: 'Most users will only land on 1 content piece before ending a session. Sessions that include at least two (2) content pieces are considered a Journey.'
  },
  user_journey_graph: {
    title: 'Journey Breakdown',
    text: 'How many content pieces were visited during a single journey'
  },
  direct_none_traffic: {
    title: 'Direct/None',
    text: '"Direct/None" traffic covers all views that do not come from a public website, such as traffic from email links, shortened URLs, or browser bookmarks.'
  }
};
var _default = TooltipText;
exports["default"] = _default;

//# sourceMappingURL=TooltipText.js.map